module.exports = __webpack_public_path__ + "img/Machine5.4b31437d.svg";